import { motion } from 'framer-motion';
import RevealFadeIn from '@/components/reveal-animations/RevealFadeIn/RevealFadeIn';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';
import MixedTitle from '../../molecules/MixedTitle/MixedTitle';
import Button from '../../atoms/Button/Button';
import styles from './ThankYouMessage.module.css';

interface ThankYouMessageProps {
  onReset: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
}

function ThankYouMessage({ onReset, title = '', message = '', buttonText = '' }: ThankYouMessageProps) {
  return (
    <motion.div
      key="thanks"
      className={styles.container}
      initial={{ opacity: 0, x: '50%', scale: 0.9 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: '50%', scale: 0.9 }}
      transition={{ duration: 0.2 }}
    >
      <RevealFadeIn>
        <MixedTitle
          className={styles.title}
          title={title}
          seoTitleTag="h3"
          color={ColorThemeEnum.BLACK}
          colorSpan={ColorThemeEnum.ORANGE}
          size="h3"
          sizeSpan="m3"
        />
      </RevealFadeIn>
      <p className={styles.message}>
        <span className={styles.messageText}>{message}</span>
      </p>

      <div className={styles.buttonContainer}>
        <Button color={ColorThemeEnum.ORANGE} onClick={onReset} className={styles.button}>
          {buttonText}
        </Button>
      </div>
    </motion.div>
  );
}

export default ThankYouMessage;
